import { PROJECT_VERSION } from './PROJECT_VERSION.js';
export const projectInfo = {
    projectName: 'Vike',
    projectVersion: PROJECT_VERSION
};
